import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Draw"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M14.355 21C13.3135 21.0041 12.3728 20.378 11.9747 19.4155C11.5766 18.4531 11.7999 17.3454 12.54 16.6125L16.395 12.75C16.7049 12.4916 16.8421 12.0803 16.7495 11.6875C16.6568 11.2948 16.3502 10.9882 15.9575 10.8956C15.5648 10.8029 15.1534 10.9401 14.895 11.25L9.75 16.3875C8.734 17.3638 7.1285 17.3638 6.1125 16.3875C5.11324 15.3838 5.11324 13.7612 6.1125 12.7575L12.5475 6.32252C12.8574 6.0641 12.9946 5.65276 12.902 5.26005C12.8093 4.86734 12.5027 4.56072 12.11 4.46806C11.7173 4.37541 11.3059 4.51264 11.0475 4.82252L4.8075 11.025L3.75 9.97502L9.9675 3.75002C10.9847 2.82924 12.5456 2.86886 13.5148 3.84007C14.484 4.81127 14.5204 6.37219 13.5975 7.38752L7.17 13.815C6.75817 14.2302 6.75817 14.8998 7.17 15.315C7.59 15.715 8.25 15.715 8.67 15.315L13.815 10.17C14.4518 9.46647 15.4243 9.17067 16.345 9.40042C17.2658 9.63017 17.9852 10.3482 18.2169 11.2684C18.4485 12.1887 18.1547 13.1617 17.4525 13.8L13.59 17.6625C13.2371 18.0857 13.2653 18.7081 13.6548 19.0977C14.0444 19.4873 14.6669 19.5154 15.09 19.1625L18.42 15.84L19.5 16.92L16.17 20.25C15.6903 20.7337 15.0362 21.004 14.355 21Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Draw.vue"]]);
